<template>
  <div class="wu-overlay" @click.self="$emit('close')">
    <div class="wu-modal">
      <h5>Слово: «{{ word }}» — блок: {{ blockName }}</h5>
      <div class="wu-hint">Фразы utm_term, содержащие это слово. Порог фильтра здесь не применяется.</div>

      <table class="table table-sm">
        <thead>
          <tr><th style="width:45%">utm_term</th><th>Метрики</th></tr>
        </thead>
        <tbody>
          <template v-for="item in phrases" :key="item.phrase">
            <tr class="wu-phrase" @click="togglePhrase(item.phrase)">
              <td>{{ expanded[item.phrase] ? '▾' : '▸' }} {{ item.phrase }}</td>
              <td>{{ format(item.metrics) }}</td>
            </tr>
            <tr v-if="expanded[item.phrase]">
              <td colspan="2" class="wu-rules">
                <BalansirRules :phrase="item.phrase"/>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <div v-if="phrases.length === 0" class="text-muted">Фраз с этим словом не найдено.</div>

      <div class="wu-actions">
        <button class="btn btn-outline-secondary" @click="$emit('close')">Закрыть</button>
      </div>
    </div>
  </div>
</template>

<script>
import { findPhrasesWithWord, formatMetrics } from '@/utils/wordStat';
import BalansirRules from '@/components/BalansirRules.vue';

export default {
  name: 'WordUtmModal',
  components: { BalansirRules },
  props: {
    word: { type: String, required: true },
    blockName: { type: String, default: '' },
    utm: { type: Object, default: () => ({}) },
  },
  emits: ['close'],
  data() {
    return {
      expanded: {},
    };
  },
  computed: {
    phrases() {
      return findPhrasesWithWord(this.utm, this.word);
    },
  },
  methods: {
    format(metrics) {
      return formatMetrics(metrics);
    },
    togglePhrase(phrase) {
      this.expanded[phrase] = !this.expanded[phrase];
    },
  },
};
</script>

<style scoped>
.wu-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 1050; }
.wu-modal { background: var(--surface-1); color: var(--text-primary); border-radius: 6px; padding: 1.5em; width: 900px; max-width: 95vw; max-height: 85vh; overflow-y: auto; text-align: left; }
.wu-hint { color: #666; font-size: .9em; margin-bottom: .8em; }
.wu-actions { display: flex; justify-content: flex-end; margin-top: 1em; }
.wu-phrase { cursor: pointer; }
.wu-phrase:hover { background: var(--page); }
.wu-rules { background: var(--page); }
</style>
